import { GeneralSettingsState, initialState } from '../state/general.state';
import { GeneralActions, GET_GENERAL_SETTINGS_SUCCESS, PUSH_AVAILABLE_CONFIGURATION } from '../actions/general.action';

export function GeneralReducer(
    state: GeneralSettingsState = initialState,
    action: GeneralActions
): GeneralSettingsState {
    switch (action.type) {
        case GET_GENERAL_SETTINGS_SUCCESS: {
            return {
                ...state,
                settings: action.payload
            };
        }

        case PUSH_AVAILABLE_CONFIGURATION: {
            return {
                ...state,
                availableConfiguration: action.payload
            };
        }

        default: return state;
    }
}